import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";

export default function ConfirmDialog({ open, onOpenChange, title, message, confirmLabel = "Confirm", danger = false, onConfirm, busy = false }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="!bg-[#14171A] !border-[#24272B] !rounded-none !max-w-md p-0 text-[#E8E6E1]"
        data-testid="confirm-dialog">
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <DialogDescription className="sr-only">{message}</DialogDescription>
        <div className="p-8">
          <span className="t-label">{title}</span>
          <p className="t-small text-muted-s mt-3 measure">{message}</p>
          <div className="flex gap-3 mt-7 justify-end">
            <button className="btn-ghost" onClick={() => onOpenChange(false)} data-testid="confirm-cancel-button">Cancel</button>
            <button
              className="btn-primary"
              style={danger ? { background: "#B4462F", borderColor: "#B4462F" } : undefined}
              disabled={busy}
              onClick={onConfirm}
              data-testid="confirm-accept-button">
              {busy ? "Working" : confirmLabel}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
